// extracted by mini-css-extract-plugin
module.exports = {"card":"_f121275"};